import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const MySkillBox = styled.div`
  max-width: 1128px;
  margin: auto;
  padding: 20px 0px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  @media (max-width: 1100px) {
    margin: 0px 30px;
  }
  @media (max-width: 768px) {
    margin: 10px 10px;
    flex-direction: column;
    padding: 30px 0 10px;
  }
`;

export const MyItemSkillBox = styled.div`
  transition: all 0.3s ease-in-out;
  width: 50%;
  border-radius: 10px;

  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--primary);
    text-decoration: none;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  color: var(--secondary);
  font-size: 1.5rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const SubTitle = styled.p`
  padding-top: 5px;
  color: var(--secondary);
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding-top: 5px;
  }
`;

export const ImageContainer = styled.img`
  height: 35px;
  width: 35px;
  padding: 10px;
  border-radius: 50%;
  border: 0.2rem solid var(--secondary);

  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--secondary);
    border: 0.2rem solid var(--primary);
  }
`;

export const SoftwareSkillContainer = styled.div`
  max-width: 1128px;
  margin: auto;
  padding: 0px 0px 20px 0px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  @media (max-width: 1100px) {
    /* margin-left: 30px; */
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
